// COPYRIGHT © 2019 Esri
//
// All rights reserved under the copyright laws of the United States
// and applicable international laws, treaties, and conventions.
//
// This material is licensed for use under the Esri Master License
// Agreement (MLA), and is bound by the terms of that agreement.
// You may redistribute and use this code without modification,
// provided you adhere to the terms of the MLA and include this
// copyright notice.
//
// See use restrictions at http://www.esri.com/legal/pdfs/mla_e204_e300/english
//
// For additional information, contact:
// Environmental Systems Research Institute, Inc.
// Attn: Contracts and Legal Services Department
// 380 New York Street
// Redlands, California, USA 92373
// USA
//
// email: contracts@esri.com
//
// See http://js.arcgis.com/next/esri/copyright.txt for details.

define({widgetLabel:"Jelmagyarázat",points:"Pontok",lines:"Vonalak",polygons:"Polygonok",creatingLegend:"Jelmagyarázat létrehozása",noLegend:"Nincs jelmagyarázat",dotValue:"1 pont = {value} {unit}",currentObservations:"Jelenlegi megfigyelések",previousObservations:"Előző megfigyelések",high:"Magas",low:"Alacsony",esriMetersPerSecond:"m/s",esriKilometersPerHour:"km/h",esriKnots:"csomó",esriFeetPerSecond:"ft/sec",esriMilesPerHour:"mph",showNormField:"{field} osztva a(z) {normField} értékével",showNormPct:"{field} az összes százalékaként",showRatio:"A(z) {field} és a(z) {normField} aránya",showRatioPercent:"{field} a(z) {normField} százalékaként",showRatioPercentTotal:"{field} a(z) {field} és {normField} százalékaként",band0:"sáv_0",band1:"sáv_1",band2:"sáv_2",red:"Vörös",green:"Zöld",blue:"Kék"});